import { PATHS } from "@config/constants";

// Adapter for legacy MiniGame module (cloned).
// Prefer using PATHS elsewhere in the app.
const PATH = {
  BID: "", // legacy code appends "/running"
  PACKAGE: "/account/package",
  MINI_GAME: PATHS.EVENT_WORLD_CUP_2026,
};

export default PATH;

